/**-------------------------------  Copyright ---------------------------------
This software has been developed by Orange Labs TGI/OLS/SOFT
Copyright (c) Orange Labs 2018

COPYRIGHT    : This file is the property of Orange Labs.
Copyright Orange Labs 2018, All Rights Reserved

This software is the confidential and proprietary information of Orange Labs.

You shall not disclose such Confidential Information and shall use it only
in accordance with the terms of the license agreement you entered into with
Orange Labs.

AUTHORS      : Orange Labs  TGI/OLS/SOFT
EMAIL        : soft.cybersec@orange.com
-----------------------------------------------------------------------------*/


import {Component, Vue} from 'vue-property-decorator'
import UserServiceMixin from '@/services/UserServiceMixin'
import {UserService} from '@/services/UserService'
import MessageBox from '@/components/shared/MessageBox'

import EmailValidator from '@/utils/validators/EmailValidator'
import {ERROR_MESSAGE_TYPE} from '@/utils/constants'

@Component({
    mixins: [UserServiceMixin],
    components: {
        MessageBox,
    },
})

export default class ForgotPassword extends Vue {
    private email: string = ''
    private errorMessage = ''
    private messageType = ERROR_MESSAGE_TYPE
    private userService: UserService // redeclared variable to avoid warnings in Webstorm

    private reloadLoginPage(message: string) {
        this.$emit('setLoginPageMessage', message)
        this.$router.push({name: 'login'})
    }

    private clearErrorMessage() {
        this.errorMessage = ''
    }

    private async resetPassword() {

        if (!EmailValidator.isValid(this.email)) {
            this.errorMessage = 'Please enter a valid email address'
            return
        }

        try {
            await this.userService.passwordForgot(this.email)
            this.reloadLoginPage('You will receive an email with a link to reset your password.')
        } catch (e) {
            this.errorMessage = 'Sending of email to reset the password failed. ' + e.errorMessage
        }
    }
}
